<template>
  <div class="circle-progress">
    <canvas v-if="canvasId != null" :id="canvasId" :width="cradius * 2" :height="cradius * 2"></canvas>
  </div>
</template>

<script>
import { string } from "mathjs";

export default {
  name: "circle_progress",
  data() {
    return {
      canvas: "",
      percent: "",
      ctx: "",
      circleX: "",
      circleY: "",
      radius: "",
      cradius: "",
      lineWidth: "",
      process: "",

      circleLoading: null,
    };
  },
  props: {
    canvasId: {
      type: String,
      default: null,
    },
    textColor: {
      type: String,
      default: "white",
    },
    fontSize: {
      type: Number,
      default: 12,
    },

    color: {
      type: String,
      default: "#ffbf00",
    },
    radius: {
      type: Number,
      default: 30,
    },
    cradius: {
      type: Number,
      default: 40,
    },
    lineWidth: {
      type: Number,
      default: 4,
    },
    percent: {
      type: Number,
      default: 0,
    },
    desc: {
      type: String,
      default: null,
    },
  },
  watch: {
    percent(n, o) {
      this.toCanvas(this.canvasId);
    },
  },
  mounted() {
    this.toCanvas(this.canvasId);
  },
  methods: {
    //画圆
    circle(cx, cy, r) {
      this.ctx.beginPath();
      //ctx.moveTo(cx + r, cy);
      this.ctx.lineWidth = this.lineWidth;
      this.ctx.lineCap = "round";
      this.ctx.strokeStyle = "#eee";
      this.ctx.arc(cx, cy, r, Math.PI, Math.PI * 2);
      this.ctx.stroke();
    },
    //画弧线
    sector(cx, cy, r, startAngle, endAngle, anti) {
      this.ctx.beginPath();
      //ctx.moveTo(cx, cy + r); // 从圆形底部开始画
      this.ctx.lineWidth = this.lineWidth;
      // 进度条颜色
      this.ctx.strokeStyle = this.color;
      //圆弧两端的样式
      this.ctx.lineCap = "round";
      //圆弧
      if (this.percent > 0) {
        this.ctx.arc(cx, cy, r, startAngle, startAngle + (endAngle / 100) * Math.PI, false);
      } else {
      }
      this.ctx.stroke();
    },
    //刷新
    loading(progress) {
      if (this.process >= this.percent) {
        this.process = this.percent;
        clearInterval(this.circleLoading);
      }
      //清除canvas内容
      this.ctx.clearRect(0, 0, this.circleX * 2, this.circleY * 2);
      //中间的字
      this.ctx.font = this.fontSize + "px April";
      this.ctx.textAlign = "center";
      this.ctx.textBaseline = "middle";
      this.ctx.fillStyle = this.textColor;
      this.ctx.fillText(parseFloat(this.process).toFixed(1) + "%", this.circleX, this.circleY - 10);
      this.ctx.fillText(this.desc, this.circleX, this.circleY + 12);

      //圆形
      this.circle(this.circleX, this.circleY, this.radius);
      //圆弧
      this.sector(this.circleX, this.circleY, this.radius, Math.PI, this.process);
      //控制结束时动画的速度
      if (this.process / this.percent > 0.9) {
        this.process += 0.3;
      } else if (this.process / this.percent > 0.8) {
        this.process += 0.55;
      } else if (this.process / this.percent > 0.7) {
        this.process += 0.75;
      } else {
        this.process += 1.0;
      }
    },
    /** 生成环形进度条 **/
    toCanvas(id, progress) {
      //canvas进度条
      this.canvas = document.getElementById(id);
      this.ctx = this.canvas.getContext("2d");
      this.circleX = this.canvas.width / 2; //中心x坐标
      this.circleY = this.canvas.height / 2; //中心y坐标
      this.process = 0; //进度
      this.circleLoading = window.setInterval(() => {
        this.loading(progress);
      }, 20);
    },
  },
};
</script>
<style lang="less"></style>
